import { __extends } from "tslib";
import * as React from 'react';
import * as _ from 'lodash';
import { MediaFrameMediaType, ProductType } from '@wix/wixstores-client-core';
import * as Icons from '../icons/dist';
import classNames from 'classnames';
import s from './ProductThumbnail.scss';
import { ProductImage } from '../ProductImage';
import { DefaultProductImage } from '../DefaultProductImage/DefaultProductImage';
export var DataHook;
(function (DataHook) {
    DataHook["Wrapper"] = "product-thumbnail-wrapper";
    DataHook["Media"] = "product-thumbnail-media";
    DataHook["Badge"] = "product-badge";
    DataHook["DefaultImage"] = "default-image";
})(DataHook || (DataHook = {}));
export var DEFAULT_DIMENSION = 120;
export var DEFAULT_IMAGE_DEFAULT_SIZE = 50;
var ProductThumbnail = /** @class */ (function (_super) {
    __extends(ProductThumbnail, _super);
    function ProductThumbnail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconsByFileType = function (product, iconSize) {
            var _a;
            var fileType = _.get(product, 'digitalProductFileItems[0].fileType', null);
            var size = iconSize.toString();
            var icons = (_a = {},
                _a[MediaFrameMediaType.SECURE_DOCUMENT] = React.createElement(Icons.DocumentDigitalProductDefaultImage, { size: size }),
                _a[MediaFrameMediaType.SECURE_PICTURE] = React.createElement(Icons.PictureDigitalProductDefaultImage, { size: size }),
                _a[MediaFrameMediaType.SECURE_VIDEO] = React.createElement(Icons.VideoDigitalProductDefaultImage, { size: size }),
                _a[MediaFrameMediaType.SECURE_MUSIC] = React.createElement(Icons.MusicDigitalProductDefaultImage, { size: size }),
                _a[MediaFrameMediaType.SECURE_ARCHIVE] = React.createElement(Icons.DocumentDigitalProductDefaultImage, { size: size }),
                _a);
            return icons[fileType] || icons[MediaFrameMediaType.SECURE_DOCUMENT];
        };
        _this.getDefaultImage = function (product, size) {
            if (product.productType === ProductType.DIGITAL) {
                return _this.iconsByFileType(product, size);
            }
            else {
                return React.createElement(Icons.PhysicalProductDefaultImage, { size: size.toString() });
            }
        };
        _this.renderBadge = function () {
            var _a = _this.props, _b = _a.showBadge, showBadge = _b === void 0 ? true : _b, product = _a.product, digitalProductBadgeTranslationKey = _a.digitalProductBadgeTranslationKey;
            return (showBadge &&
                product.productType === ProductType.DIGITAL && (React.createElement("div", { className: s.productBadge, "data-hook": DataHook.Badge, "aria-label": digitalProductBadgeTranslationKey },
                React.createElement(Icons.DigitalProductBadge, null))));
        };
        _this.renderDefaultImageThumbnail = function () {
            var _a = _this.props, product = _a.product, width = _a.width, height = _a.height, defaultImageClassName = _a.defaultImageClassName, defaultImageIconSize = _a.defaultImageIconSize, className = _a.className, _b = _a.alwaysShowBadge, alwaysShowBadge = _b === void 0 ? false : _b, _c = _a.useNewDefaultProductImage, useNewDefaultProductImage = _c === void 0 ? false : _c;
            var defaultImageWidth = width || height || DEFAULT_DIMENSION;
            var defaultImageHeight = height || width || DEFAULT_DIMENSION;
            var defaultImageSize = defaultImageIconSize || DEFAULT_IMAGE_DEFAULT_SIZE;
            var style = { width: defaultImageWidth, height: defaultImageHeight };
            if (useNewDefaultProductImage) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(DefaultProductImage, { className: classNames(s.defaultImage, className, defaultImageClassName), imageSize: defaultImageSize, imageContainerDimensions: style, dataHook: DataHook.DefaultImage }),
                    alwaysShowBadge && _this.renderBadge()));
            }
            else {
                return (React.createElement("div", { "data-hook": DataHook.DefaultImage, className: classNames(s.defaultImage, className, defaultImageClassName), style: style },
                    _this.getDefaultImage(product, defaultImageSize),
                    alwaysShowBadge && _this.renderBadge()));
            }
        };
        _this.renderImage = function (mediaItem) {
            var _a = _this.props, product = _a.product, width = _a.width, height = _a.height, className = _a.className, _b = _a.hasFixedSize, hasFixedSize = _b === void 0 ? true : _b, imageClassName = _a.imageClassName, _c = _a.withSrcSet, withSrcSet = _c === void 0 ? true : _c, onImageLoad = _a.onImageLoad, mountedToDOM = _a.mountedToDOM, imgDataHook = _a.imgDataHook;
            var aspectRatio = mediaItem.width / mediaItem.height;
            var alt = mediaItem.altText || product.name;
            var imageWidth = width || (height ? aspectRatio * height : null) || DEFAULT_DIMENSION;
            var imageHeight = height || (width ? width / aspectRatio : null) || DEFAULT_DIMENSION;
            return (React.createElement("div", { className: classNames(s.productImage, className), "data-hook": DataHook.Wrapper },
                React.createElement(ProductImage, { mediaItem: mediaItem, dimensions: { width: imageWidth || DEFAULT_DIMENSION, height: imageHeight || DEFAULT_DIMENSION }, mountedToDOM: mountedToDOM, imgDataHook: imgDataHook || DataHook.Media, className: imageClassName, imageLoaded: onImageLoad, withSrcSet: withSrcSet, altText: alt, hasFixedSize: hasFixedSize }),
                _this.renderBadge()));
        };
        return _this;
    }
    ProductThumbnail.prototype.render = function () {
        var _a = this.props, product = _a.product, _b = _a.mediaItemIndex, mediaItemIndex = _b === void 0 ? 0 : _b;
        var mediaItem = product.media.length > mediaItemIndex && product.media[mediaItemIndex];
        return mediaItem ? this.renderImage(mediaItem) : this.renderDefaultImageThumbnail();
    };
    return ProductThumbnail;
}(React.Component));
export { ProductThumbnail };
//# sourceMappingURL=ProductThumbnail.js.map